import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useOrdersStore } from '../store/ordersStore'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../components/ui/SafeIcon'

const { FiCheckCircle, FiPackage, FiMail, FiHome } = FiIcons

function OrderSuccessPage() {
  const { orderId } = useParams()
  const { getOrderById } = useOrdersStore()
  const order = getOrderById(orderId)

  if (!order) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Bestellung nicht gefunden</h2>
          <Link to="/orders" className="text-blue-600 hover:underline">
            Zu meinen Bestellungen
          </Link>
        </div>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>Bestellung erfolgreich | 1688Euro.com</title>
      </Helmet>

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Success Icon */}
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <SafeIcon icon={FiCheckCircle} className="w-8 h-8 text-green-600" />
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Vielen Dank für Ihre Bestellung!
          </h1>
          
          <p className="text-lg text-gray-600 mb-8">
            Ihre Bestellung <strong>#{order.id}</strong> wurde erfolgreich aufgegeben und wird bearbeitet.
          </p>

          {/* Order Summary */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8 text-left">
            <h2 className="text-xl font-bold mb-4">Bestellübersicht</h2>
            
            <div className="space-y-2 mb-4">
              <div className="flex justify-between">
                <span>Bestellnummer:</span>
                <span className="font-mono">{order.id}</span>
              </div>
              <div className="flex justify-between">
                <span>Bestelldatum:</span>
                <span>{new Date(order.createdAt).toLocaleDateString('de-DE')}</span>
              </div>
              <div className="flex justify-between">
                <span>Gesamtsumme:</span>
                <span className="font-bold">{order.totals.total.toFixed(2)} €</span>
              </div>
              <div className="flex justify-between">
                <span>Status:</span>
                <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-sm">
                  {order.status}
                </span>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-4">
              <h3 className="font-bold mb-2">Artikel:</h3>
              {order.items.map((item, index) => (
                <div key={index} className="flex justify-between text-sm">
                  <span>{item.name?.de || item.name} (×{item.quantity})</span>
                  <span>{(item.price * item.quantity).toFixed(2)} €</span>
                </div>
              ))}
            </div>
          </div>

          {/* Next Steps */}
          <div className="bg-blue-50 rounded-lg p-6 mb-8">
            <h2 className="text-lg font-bold mb-4">Was passiert als nächstes?</h2>
            <ul className="space-y-2 text-left">
              <li className="flex items-center">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-blue-600 mr-2" />
                Sie erhalten eine Bestätigungs-E-Mail mit allen Details
              </li>
              <li className="flex items-center">
                <SafeIcon icon={FiPackage} className="w-5 h-5 text-blue-600 mr-2" />
                Unser Team kümmert sich um die Bestellung bei den Herstellern
              </li>
              <li className="flex items-center">
                <SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-blue-600 mr-2" />
                Wir halten Sie über den Status Ihrer Bestellung auf dem Laufenden
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/orders"
              className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Meine Bestellungen ansehen
            </Link>
            
            <Link
              to="/search"
              className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
            >
              Weiter einkaufen
            </Link>
            
            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 text-gray-600 hover:text-gray-800"
            >
              <SafeIcon icon={FiHome} className="w-5 h-5 mr-2" />
              Zur Startseite
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderSuccessPage